/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
 // initialize owl slider on testimonials
 function initOwlSlider() {
     var owlDanbro = jQuery("#owl-danbro");

     owlDanbro.owlCarousel({
         autoplay: true,
         loop: true,
         autoplayTimeout: 7000,
         items: 1,
         itemsDesktop: [1199, 3],
         itemsDesktopSmall: [979, 3],
         navigation: true,
         navigationText: false,
         animateIn: 'fadeInRightBig',
         animateOut: 'fadeOutLeftBig'
     });
 }


 function initMatchHeight() {
     jQuery('.match-height').matchHeight();
 }

 function initMatchHeightTwo() {
    jQuery('.match-height-two').matchHeight();
}


function resourceRedirect() {
    var urlPath = window.location.pathname;

    if (urlPath.indexOf('/resources/') === 0) {
        var baseUrl = 'http://localhost:3000/thank-you/';
        var backgroundImage = '';

        console.log(baseUrl + '?resource_url=' + jQuery('#resource-file-url').val());

        document.addEventListener( 'wpcf7mailsent', function( event ) {
            event.target.setAttribute("target", "_blank");
            location = baseUrl + '?resource_url=' + jQuery('#resource-file-url').val();
        }, false );
    }
}

function vacanciesRedirect() {
    var urlPath = window.location.pathname;

    if (urlPath.indexOf('/vacancies/') === 0) {
        var baseUrl = 'http://platinum-eng.co.uk/vacancy-thank-you/';
        var backgroundImage = '';

        console.log(baseUrl + '?vacancy_url=' + jQuery('#vacancy-file-url').val());

        document.addEventListener( 'wpcf7mailsent', function( event ) {
            event.target.setAttribute("target", "_blank");
            location.href = baseUrl + '?vacancy_url=' + jQuery('#vacancy-file-url').val();
        }, false );
    }
}


(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        try {
            headerDynamicBackground();
        } catch(e) {}

        try {
            $('.launch-modal').on('click', function(e){
                e.preventDefault();
                $( '#' + $(this).data('modal-id') ).modal();
            });
        } catch(e) {}
        try {
            initOwlSlider();
            initMatchHeight();
            initMatchHeightTwo();
        } catch(e) {}

        try {
            resourceRedirect();
            vacanciesRedirect();
        } catch(e) {}
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    // Vacancies Single page
    'single_vacancies': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        try {
        jQuery('[name=vacancy-name]').val((jQuery('#vacancy-title').html()));
        } catch(e) {}
      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
